import { createAction } from '@reduxjs/toolkit'
import { engLocaleType } from 'shared/locale/en-US'

export const changeLang = createAction<engLocaleType>('@locale/CHANGE_LANG')
